var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "dialog-content" }, [
      _c(
        "div",
        { staticClass: "row-name" },
        [
          _vm._v(" 是否下架 "),
          _vm._l(_vm.dialogInfo.titleArr, function (item, index) {
            return [
              _c("label", [_vm._v(_vm._s(item))]),
              index < _vm.dialogInfo.titleArr.length - 1
                ? _c("span", [_vm._v("、")])
                : _vm._e(),
            ]
          }),
          _vm._v(" 商品？ "),
        ],
        2
      ),
      _c("div", { staticClass: "row-content" }, [
        _vm._v("下架商品后，以下礼包也会同步下架，请确认是否下架商品。"),
      ]),
      _c("div", { staticClass: "gift-msg" }, [
        _c("div", [_vm._v("受到影响的礼包：")]),
        _c(
          "ul",
          { staticClass: "gift-msg-list" },
          _vm._l(_vm.list, function (item) {
            return _c("li", [_vm._v(_vm._s(item.name))])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }